import cls from 'classnames';
import { SyntheticEvent } from 'react';

import encodeQueryData from '../../../utils/encodeQueryData';
import { Tooltip } from '../Tooltip';

import useStyles from './styles';
import { AppSwitcherItemProps } from './types';

export default function AppSwitcherItem({
  tooltip,
  value,
  text,
  url,
  isSelected,
  queryData,
  onItemClick,
}: AppSwitcherItemProps) {
  const classes = useStyles();
  const onClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (!isSelected) {
      const href =
        queryData?.fontData[0].length > 0 ? `${url}?t=${encodeQueryData(queryData)}` : url;

      window.location.href = href;
      onItemClick(value);
    }
  };
  return (
    <div className={classes.buttonContainer}>
      <a
        href={url}
        className={cls(classes.button, isSelected && classes.selected)}
        onClick={onClick}
      >
        {text}
      </a>

      {tooltip && !isSelected && (
        <div className={classes.tooltipContainer}>
          <Tooltip arrowType="up">{tooltip}</Tooltip>
        </div>
      )}
    </div>
  );
}
